"use client";

import { Eye, Gavel, ShieldCheck } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
export default function Certifications() {
  const shouldReduceMotion = useReducedMotion();
  const cards = [{
    icon: ShieldCheck,
    title: "Qualidade Certificada.",
    description: "Implementamos rigorosos protocolos de controlo de qualidade em todos os nossos sistemas, garantindo conformidade com as normas industriais mais exigentes do mercado.",
    certs: ["ISO 9001", "CE", "TÜV"]
  }, {
    icon: Gavel,
    title: "Normas de Segurança.",
    description: "A segurança é a nossa prioridade. Todos os equipamentos cumprem as diretivas europeias de segurança, assegurando uma operação fiável e protegida em ambiente industrial.",
    certs: ["ATEX", "NR-12"]
  }, {
    icon: Eye,
    title: "Excelência Técnica.",
    description: "Como representantes da Spraying Systems Co., garantimos padrões de engenharia de topo, com documentação técnica completa e suporte especializado contínuo.",
    certs: ["SSC", "Eng"]
  }];
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.12
      }
    }
  };
  const cardVariants = {
    hidden: shouldReduceMotion ? {
      opacity: 0
    } : {
      opacity: 0,
      y: 24
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0.2 : 0.64,
        ease: [0.22, 0.61, 0.36, 1] as [number, number, number, number]
      }
    }
  };
  return <section data-section-id="31364" id="certificationsandqualityassurance" className="bg-background text-foreground py-32 md:py-44">
      <div className="mx-auto w-full max-w-[1360px] px-6 md:px-10">
        {}
        <div className="mx-auto max-w-[780px] text-center">
          <motion.p initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.6
        }} transition={{
          duration: 0.5,
          ease: [0.22, 0.61, 0.36, 1]
        }} className="font-default text-xs font-medium uppercase tracking-[0.22em] text-muted-foreground">
            Qualidade e Normas
          </motion.p>

          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          duration: 0.64,
          ease: [0.22, 0.61, 0.36, 1],
          delay: 0.08
        }} className="font-default mt-6 text-4xl font-medium leading-[1.06] tracking-tight md:text-5xl lg:text-6xl text-foreground">
            Compromisso com a{" "}
            <span className="text-primary">excelência</span> técnica.
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          duration: 0.64,
          ease: [0.22, 0.61, 0.36, 1],
          delay: 0.16
        }} className="font-default mx-auto mt-8 max-w-[640px] text-lg leading-[1.55] text-muted-foreground">
            Certificações internacionais, conformidade rigorosa e engenharia de precisão — garantindo a máxima fiabilidade para a sua indústria.
          </motion.p>
        </div>

        {}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }} className="mt-20 grid grid-cols-1 gap-6 md:mt-24 md:grid-cols-3 md:gap-7">
          {cards.map((card, i) => {
          const Icon = card.icon;
          return <motion.div key={i} data-index={i} variants={cardVariants} whileHover={shouldReduceMotion ? undefined : {
            y: -4,
            transition: {
              duration: 0.32,
              ease: [0.22, 0.61, 0.36, 1]
            }
          }} className="group relative flex min-h-[480px] flex-col rounded-2xl p-8 md:p-11 transition-colors duration-300 bg-card border border-border shadow-sm">
                {}
                <div className="mb-8 flex h-12 w-12 items-center justify-center transition-all duration-300">
                  <Icon strokeWidth={1.25} className="h-12 w-12 text-primary" aria-hidden="true" />
                </div>

                {}
                <h3 className="font-default text-2xl font-medium leading-[1.15] tracking-tight md:text-[2rem] text-foreground">
                  {card.title}
                </h3>

                {}
                <p className="font-default mt-6 text-base leading-[1.6] text-muted-foreground">
                  {card.description}
                </p>

                {}
                <div className="flex-1" />

                {}
                <div className="mt-8 h-px w-full bg-border" aria-hidden="true" />

                {}
                <div className="mt-6 flex flex-wrap gap-2">
                  {card.certs.map((cert, j) => <div key={j} data-index={j} className="flex h-10 items-center justify-center rounded-lg px-4 bg-muted border border-border">
                      <span className="font-default text-xs font-medium tracking-wide text-foreground">
                        {cert}
                      </span>
                    </div>)}
                </div>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}